import { makeStyles } from "@mui/styles";
import { grey } from "@mui/material/colors";
import background from '../../assets/registration/blue-wave.jpg'

const useStyles = makeStyles(theme => ({
    root:{
        backgroundImage:`url(${background})`,
        width:'100%',
        height:'100vh',
        position:'relative'
    },
    subroot:{
        overflowY:'auto',
        overflowX:'hidden',
        maxHeight:'100vh',

    },
    container:{
        width:800,
        margin:'auto',
        paddingBottom:80,
        boxSizing:'border-box',
        [theme.breakpoints.down('sm')]:{
            width:'100%',
            padding:16,
            paddingBottom:40,
        }
    },
    title:{
        color:'white',
        marginTop:60,
        fontWeight:600,
        marginBottom:16,
        [theme.breakpoints.down('sm')]:{
            fontSize:36,
            marginTop:40,
        }

    },
    content:{
        color:'white',
        margin:'0px auto',
        marginTop:16,
        width:'100%',
        maxWidth:650,
        textAlign:'center',
        [theme.breakpoints.down('sm')]:{
            fontSize:16,
            maxWidth:'100%',
        }
    },
    card:{
        boxShadow:'7px 7px 20px rgb(0 0 0 / 10%)',
        padding:16,
        borderRadius:20,
        marginTop:32,
        padding:'30px 32px',
        [theme.breakpoints.down('sm')]:{
            padding:'32px 16px',
        }
    },
    subtitle:{
        fontWeight:600,
        marginBottom:16
    },
    divider:{
        background:grey[300],
        height:1,
        margin:'32px 0px'
    },
    recaptcha:{
        margin:'32px 0px'
    },
    version:{
        marginTop:32,
        color:'white'
    }
}))

export default useStyles